import React, { useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, InputAdornment, createFilterOptions, TextField } from '@mui/material';

import { useStyles } from './styled';

export const SearchBar = ({ options = [], onSelect }) => {
  const OPTIONS_LIMIT = 8;
  const filterOptions = createFilterOptions({
    limit: OPTIONS_LIMIT
  });
  const styles = useStyles();
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      id="search-box"
      className={styles.inputRoot}
      onInputChange={(e) => setInputValue(e?.target?.value)}
      options={options}
      getOptionLabel={({ ticker, token_name }) =>
        ticker ? `${token_name}(${ticker})` : `${token_name}`
      }
      clearOnBlur={true}
      clearOnEscape={true}
      disableClearable={true}
      forcePopupIcon={false}
      style={{ width: 300 }}
      filterOptions={filterOptions}
      open={inputValue?.length > 0}
      onChange={(e, value) => {
        setInputValue('');
        onSelect(value.token_id, value.token_name, value.token_type);
      }}
      onClose={(e) => {
        setInputValue('');
        e.target.parentNode.blur();
      }}
      inputValue={inputValue}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            label="Search IDO/IEO/ICO/NFT"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        );
      }}
    />
  );
};
